var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-button-group',{class:_vm.customClass},[_c('el-button',{attrs:{"size":"small","icon":"el-icon-check"},on:{"click":_vm.onSelectAll}},[_vm._v("\n        Select All\n    ")]),_vm._v(" "),_c('el-button',{attrs:{"size":"small","icon":"el-icon-close"},on:{"click":_vm.onClearSelection}},[_vm._v("\n        Clear Selection\n    ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }